//DataTable.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as ResultsFS from "../Util/ResultsFS";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import { Button, CssBaseline, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

//ESRI javascript API.
import Query from "@arcgis/core/rest/support/Query";
import * as QueryTask from "@arcgis/core/rest/query";

let id: string;
let popupSpec: Settings.iPopUpTable;
let results: ResultsFS.iResult[];

//Show the dialog.
export function show(title: string, idValue: string) {
   popupSpec = Util_App.getDataTableSpec(title);
   id = idValue;
   popupSpec.heading = popupSpec.heading.replace("ID_Here", id);
   popupSpec.whereStr = popupSpec.whereStr.replace("ID_Here", id);
   getData();
}

//Get popup table data.
function getData() {
   const query = new Query({
      returnGeometry: false,
      outFields: ["*"],
      orderByFields: [popupSpec.orderBy],
      where: popupSpec.whereStr
   });

   //Execute query.
   QueryTask.executeQueryJSON(popupSpec.tableURL, query).then(queryTask_success).catch(queryTask_failed);
}

//Query completed.
function queryTask_success(fs: __esri.FeatureSet) {
   Util.logMsg("Rendering data table");

   const result_rec: ResultsFS.iResult = {
      toolName: "Data Table",
      layerName: popupSpec.title,
      fs: fs, IDs: [id], begRec: 0, numRec: fs.features.length,
      layerNameVisible: false, append: false,
   };
   results = [result_rec];

   if (!Settings.dialogDivRoot) {
      Settings.setDialogDivRoot(ReactDOM.createRoot(document.getElementById("dialog_div")));
   }
   Settings.dialogDivRoot.render(<Render key={Util.uid()} />);
}

//Query task failed.
function queryTask_failed(error: Error) {
   const msg = "QueryTask failed. URL of table: " + popupSpec.tableURL + " ";
   Util.errMsg(msg, error);
}

//Render function.
export function Render() {

   //Define state.
   const [visible, setVisible] = React.useState(true); //Set refresh method.

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Close dialog.
   function handleClose() {
      setVisible(false);
   }

   //css styles.
   const styles: Default.iStyles = {
      title: { backgroundColor: Settings.primaryColor, color: 'white', fontWeight: 500, paddingLeft: 5, paddingRight: 5 },
   };

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />

         <Dialog
            open={visible}
            onClose={handleClose}
            aria-labelledby="data-table-title"
            aria-describedby="data-table-description"
         >
            <DialogTitle id="data-table-title" style={{ paddingBottom: 0, paddingTop: 9 }}>
               <div className="app-flex-row-around">
                  <div style={styles.title}>{popupSpec.title}</div>
                  <div>{popupSpec.heading}</div>
               </div>
            </DialogTitle>

            <DialogContent>
               <ResultsFS.Render results={results} />
            </DialogContent>

            <DialogActions>
               <Button onClick={handleClose} color="primary">
                  Close
               </Button>
            </DialogActions>
         </Dialog>
      </ThemeProvider>
   ); //end return.

} //end function.
